import { useMemo } from 'react';

import { BaseInputProps, OptionItem } from './index.types';

export function useBaseInputController(props: BaseInputProps) {
  const {
    value = '',
    onChange,
    options,
    getLabel,
    variant: _variant,
    readonly,
    disabled,
    ...rest
  } = props;

  const variant =
    _variant === 'minimal' ? 'standard' : (_variant ?? 'outlined');

  const optionMap = useMemo(() => {
    const map: Record<string, OptionItem> = {};
    options?.forEach((opt) => {
      map[opt.value] = opt;
    });
    return map;
  }, [options]);

  const handleChange = (_: unknown, newValue: string) => {
    onChange?.(newValue);
  };

  const handleInputChange = (_: unknown, newValue: string) => {
    onChange?.(newValue);
  };

  const getOptionLabel = (option: string) => optionMap[option]?.label ?? option;

  const displayValue = getLabel ? getLabel(value) : value;

  const isDisabled = disabled || readonly;

  return {
    value,
    displayValue,
    variant,
    optionMap,
    options,
    isDisabled,
    readonly,
    rest,
    handleChange,
    handleInputChange,
    getOptionLabel,
  };
}
